import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import Modal from '../Modal';
import styles from './DeleteSharedFolderModal.module.scss';

function DeleteSharedFolderModal(props) {
  const {
    state: { isShow, isOwner, isEditorWithRights, isMultipleDeletion },
    folderToDelete,
    foldersToDelete,
    confirmDeleteSharedFolder,
    confirmDeleteSharedFolders,
    onClose,
  } = props;

  const { t } = useTranslation();

  const handleConfirm = () => {
    if (isMultipleDeletion) {
      confirmDeleteSharedFolders();
      return;
    }

    confirmDeleteSharedFolder();
  };

  const generateFoldersName = () => {
    if (!isMultipleDeletion) {
      return folderToDelete.name;
    }

    return foldersToDelete.map(({ name, users }, index) => {
      // not display private folders
      if (!users?.length) {
        return null;
      }

      return `${name}, `;
    });
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t('delete_shared_folder_modal.header')}</span>
          <Icon src="close" className={styles.closeIcon} onClick={onClose} />
        </div>
        {(isOwner || isEditorWithRights) && (
          <div className={styles.text}>
            <span className={styles.folders}>"{generateFoldersName()}"</span>
            <span> {t('delete_shared_folder_modal.text.admin')}</span>
          </div>
        )}
        {!(isOwner || isEditorWithRights) && (
          <div className={styles.text}>
            <span className={styles.folders}>"{generateFoldersName()}"</span>
            <span> {t('delete_shared_folder_modal.text.not_admin')}</span>
          </div>
        )}
        <div className={styles.buttonsContainer}>
          <CustomButton variant="secondary" label={t('general.cancel')} onClick={onClose} />
          <CustomButton className={styles.removeBtn} variant="primary" label={t('general.remove')} onClick={handleConfirm} />
        </div>
      </div>
    </Modal>
  );
}

export default DeleteSharedFolderModal;
